import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.0488 6.19966L8.3999 3.85259L8.3999 11.9625H9.5999L9.5999 3.84451L11.9503 6.19893L12.7995 5.35113L9.43033 1.97613L9.00643 1.5515L8.5818 1.9754L5.201 5.3504L6.0488 6.19966ZM2.9999 8.4H2.3999V9V16V16.6H2.9999H14.9999H15.5999V16V9V8.4H14.9999H11.9999V9.6H14.3999V15.4H3.5999V9.6H5.9999V8.4H2.9999Z"
	})
});
export default SvgExport;
